import { render, staticRenderFns } from "./SupplierEvaluation.vue?vue&type=template&id=58972177&scoped=true&"
import script from "./SupplierEvaluation.vue?vue&type=script&lang=js&"
export * from "./SupplierEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEvaluation.vue?vue&type=style&index=0&id=58972177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58972177",
  null
  
)

export default component.exports